import { Box, CircularProgress } from '@mui/material';
import React from 'react';
import { darkTheme, lightTheme } from '../mui/theme';

interface IProps {
  isDarkTheme: boolean;
}
const LoadingSpinner = ({ isDarkTheme }: IProps) => {
  return (
    <Box
      sx={{
        minHeight: '80vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: isDarkTheme
          ? darkTheme.palette.background.default
          : lightTheme.palette.background.default,
      }}
    >
      <CircularProgress color="primary" />
    </Box>
  );
};

export default LoadingSpinner;
